import { put, takeEvery } from 'redux-saga/effects';
import URLs from '../../../constants/urls';
import { apiPython as api } from '../../../service/api';
import { fetchEmailTypesFailure, fetchEmailTypesRequest, fetchEmailTypesSuccess } from '../../features/EmailTypes/EmailTypesSlice';

function* fetchEmailTypes(action) {
  try {
    const response = yield api.get(`${URLs.GET_EMAIL_TYPES}`);
    yield put(fetchEmailTypesSuccess(response.data));
  } catch (error) {
    yield put(fetchEmailTypesFailure(error.message));
  }
}

function* emailTypesSaga() {
  yield takeEvery(fetchEmailTypesRequest.type, fetchEmailTypes);
}

export default emailTypesSaga;
